import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getProductDetails } from '../modules/selectors';

const ProductDetailsContainer = ({
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    {...props}
  />
);

const mapStateToProps = ({ content, productSwatch }) => ({
  productDetails: getProductDetails({ content, productSwatch }),
});

ProductDetailsContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(ProductDetailsContainer);
